import { selectors } from './init.js';
import { initMap, showLocationInMap } from './map.js';

export const initEventListeners = () => {
	// Event listeners
	document.addEventListener('mcflyFilterChange', (e) => {
		const category = e.detail.filterValue;
		const firstItemInList = document.querySelector(`${selectors.locationList} .location__item[data-cat="${category}"]`);
		if (firstItemInList) {
			showLocationInMap(firstItemInList.getAttribute('id'));
		}
	});

	// Listen for theme color change
	document.addEventListener('colorModeChange', initMap);
	initMap();
};
